// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { update, createOrUpdate, get } from "./operations.js";
export type {
  VaultExtendedInfoUpdateOptionalParams,
  VaultExtendedInfoCreateOrUpdateOptionalParams,
  VaultExtendedInfoGetOptionalParams,
} from "./options.js";
